import { createSelector } from 'reselect';

import { getState as getParent } from 'modules/notifications/selectors/ui';
import { getCurrentUserId } from 'modules/users/selectors/currentUser';

/**
 * @typedef {import('modules/notifications/reducer/ui/dashboard/page').ScrollPage} Page
 */

const getState = createSelector(getParent, ({ dashboard } = {}) => dashboard);

/** @returns {Array<string>} */
export const getIds = createSelector(getState, ({ ids } = {}) => ids ?? []);

/** @returns {Page} */
export const getPage = createSelector(getState, ({ page }) => page);

/** @returns {{userId: string, page: Page} */
export const getParameters = createSelector(getCurrentUserId, getPage, (userId, page) => ({ userId, page }));

/** @returns {boolean} */
export const hasNextPage = createSelector(getPage, page => !!page.last);

/** @returns {boolean} */
export const isFetching = createSelector(getState, state => state.isLoading);
